<div>
  <!-- High-Density Responsive Filters & Command Control Panel Board -->
  <div class="d-flex flex-wrap align-items-end justify-content-between gap-3 p-4 shadow-sm bg-body-tertiary">

    <!-- Left Area: Core Conditional Form Filters Matrix -->
    <div class="d-flex flex-wrap align-items-end gap-3 flex-grow-1">

      <!-- Dynamic Navigation Back Target Action Trigger -->
      @if (isCustomerPage) {
      <div>
        <button type="button"
          class="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1.5 px-3 py-2 shadow-sm text-body fw-semibold transition-base"
          (click)="goBack()">
          <i class="fa-solid fa-arrow-left font-xs"></i>
          <span>Back</span>
        </button>
      </div>
      }

      <!-- Styled Segmented Exchange Category Item Filter Toggles -->
      @if (!isCustomerPage) {
      <div class="filter-input-field flex-grow-1 max-w-300">
        <label class="form-label font-xs fw-bold text-uppercase tracking-wider text-body-secondary mb-1.5">
          Search Exchange Category
        </label>
        <div class="btn-group btn-group-sm w-100 shadow-sm bg-body rounded border p-0.5" role="group"
          aria-label="Redeem Item Category Toggles">
          @for (option of redeemTypesOption; track option.id) {
          <input type="radio" class="btn-check" name="redeemScope" [id]="option.id" [(ngModel)]="redeemType"
            [value]="option.value" (change)="onChange($event)" />
          <label class="btn btn-sm btn-outline-primary px-3 fw-bold font-monospace text-uppercase border-0 rounded"
            [for]="option.id">
            {{ option.label }}
          </label>
          }
        </div>
      </div>
      }

      <!-- Execution Progress Validation Status Selector -->
      @if (!isCustomerPage) {
      <div class="filter-input-field" style="min-width: 200px;">
        <label class="form-label font-xs fw-bold text-uppercase tracking-wider text-body-secondary mb-1.5">
          Choose a Redeem Status
        </label>
        <div class="input-group shadow-sm rounded">
          <span class="input-group-text border bg-body text-body-secondary font-xs"><i
              class="fa-solid fa-layer-group"></i></span>
          <select name="checkType" [(ngModel)]="redeemStatus"
            class="form-select form-select-sm text-body font-xs border-start-0 ps-0 font-monospace">
            @for (option of redeemStatusOption; track option) {
            <option [value]="option">{{ option }}</option>
            }
          </select>
        </div>
      </div>
      }

      @if (!isCustomerPage) {
      <!-- Calendar Timeline Start Date Picker -->
      <div class="filter-input-field">
        <label class="form-label font-xs fw-bold text-uppercase tracking-wider text-body-secondary mb-1.5">
          Start Date
        </label>
        <div class="input-group shadow-sm rounded">
          <span class="input-group-text border bg-body text-body-secondary font-xs"><i
              class="fa-solid fa-calendar-day"></i></span>
          <input type="date" [(ngModel)]="startDate"
            class="form-control form-control-sm text-body font-xs border-start-0 ps-0 font-monospace" />
        </div>
      </div>

      <!-- Calendar Timeline End Date Picker -->
      <div class="filter-input-field">
        <label class="form-label font-xs fw-bold text-uppercase tracking-wider text-body-secondary mb-1.5">
          End Date
        </label>
        <div class="input-group shadow-sm rounded">
          <span class="input-group-text border bg-body text-body-secondary font-xs"><i
              class="fa-solid fa-calendar-check"></i></span>
          <input type="date" [(ngModel)]="endDate"
            class="form-control form-control-sm text-body font-xs border-start-0 ps-0 font-monospace" />
        </div>
      </div>

      <!-- Chronological System Log Date Constraint Category Selector -->
      <div class="filter-input-field" style="min-width: 160px;">
        <label class="form-label font-xs fw-bold text-uppercase tracking-wider text-body-secondary mb-1.5">
          Date Type
        </label>
        <div class="input-group shadow-sm rounded">
          <span class="input-group-text border bg-body text-body-secondary font-xs"><i
              class="fa-solid fa-calendar-days"></i></span>
          <select class="form-select form-select-sm text-body font-xs border-start-0 ps-0 font-monospace" id="date_type"
            name="date_type" [(ngModel)]="dateType">
            <option value="REDEEMED_TS">REDEEMED_TS</option>
            <option value="PROCESSED_TS">PROCESSED_TS</option>
          </select>
        </div>
      </div>

      <!-- Filtering Query Command Action Triggers Group -->
      <div class="d-flex gap-2">
        <button type="button"
          class="btn btn-sm btn-info px-3 py-2 shadow-sm text-body fw-bold d-inline-flex align-items-center gap-1.5 transition-base"
          (click)="searchByCustomer()">
          <i class="fa-solid fa-filter font-xs"></i> <span>Check</span>
        </button>
        <button type="button"
          class="btn btn-sm btn-outline-warning px-3 py-2 shadow-sm fw-semibold d-inline-flex align-items-center gap-1.5 transition-base"
          (click)="resetForm()">
          <i class="fa-solid fa-rotate-left font-xs"></i> <span>Clear</span>
        </button>
      </div>
      }

      <!-- Right Area: Backup Document Streaming Exporter Dropdowns Group -->
      @if (!isCustomerPage) {
      @if (bolDownloadForRedeem) {
      <div class="d-flex align-items-end justify-content-sm-end mt-2 mt-md-0">
        <div class="dropdown shadow-sm">
          <button type="button"
            class="btn btn-sm btn-success dropdown-toggle d-inline-flex align-items-center gap-1.5 px-3 py-2 fw-bold"
            data-bs-toggle="dropdown" aria-expanded="false">
            <i class="fa-solid fa-file-export font-xs"></i>
            <span>Download Reports</span>
          </button>
          <ul class="dropdown-menu dropdown-menu-end shadow border-0 mt-2 font-xs">
            <li>
              <button type="button" class="dropdown-item py-2 fw-medium d-flex align-items-center gap-2"
                data-bs-toggle="modal" data-bs-target="#downloadCSVModal">
                <i class="fa-solid fa-circle-plus text-primary-emphasis"></i> Request New Extract
              </button>
            </li>
            <li>
              <hr class="dropdown-divider opacity-10">
            </li>
            <li>
              <button type="button" class="dropdown-item py-2 fw-medium d-flex align-items-center gap-2"
                (click)="goToDownloadListPage()">
                <i class="fa-solid fa-list text-body-secondary"></i> View Exports List
              </button>
            </li>
          </ul>
        </div>
      </div>
      }
      }

    </div>


  </div>

  <hr />

  <!-- Financial Ledgers Summary Dashboard Cards Matrix -->
  @if (bolSummay) {
  <div class="row g-3 mb-4 animate-fade">

    <!-- Tier 1 Core Metrics: Cumulative Aggregate Outlay Volume -->
    <div class="col-12 col-sm-6 col-md-4 col-xl">
      <div class="card border-0 shadow-sm rounded-4 bg-primary text-white h-100 card-hover-effect">
        <div class="card-body p-3.5 d-flex flex-column justify-content-between">
          <div class="text-white-50 font-xs fw-bold text-uppercase tracking-wider mb-2">
            Total Redeemed Amount
          </div>
          <div class="fs-5 fw-black font-monospace tracking-tight text-nowrap">
            {{ (totalRedeemedAmount || 0) | number }} <span class="font-xs fw-normal text-white-50">MMK</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Tier 1 Core Metrics: Pending Process Escrow Balances -->
    <div class="col-12 col-sm-6 col-md-4 col-xl">
      <div class="card border-0 shadow-sm rounded-4 bg-warning text-dark h-100 card-hover-effect">
        <div class="card-body p-3.5 d-flex flex-column justify-content-between">
          <div class="text-dark-50 font-xs fw-bold text-uppercase tracking-wider mb-2">
            Pending Redeem Amount
          </div>
          <div class="fs-5 fw-black font-monospace tracking-tight text-nowrap">
            {{ (totalPendingRedeemedAmount || 0) | number }} <span class="font-xs fw-normal text-dark-50">MMK</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Tier 1 Core Metrics: Successfully Settled Transaction Outlays -->
    <div class="col-12 col-sm-6 col-md-4 col-xl">
      <div class="card border-0 shadow-sm rounded-4 bg-success text-white h-100 card-hover-effect">
        <div class="card-body p-3.5 d-flex flex-column justify-content-between">
          <div class="text-white-50 font-xs fw-bold text-uppercase tracking-wider mb-2">
            Success Amount
          </div>
          <div class="fs-5 fw-black font-monospace tracking-tight text-nowrap">
            {{ (totalProcessedRedeemedAmount || 0) | number }} <span class="font-xs fw-normal text-white-50">MMK</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Tier 2 Channel Metrics: Wave Money Wallet Dispersals -->
    @if (bolWKBZ) {
    <div class="col-12 col-sm-6 col-md-4 col-xl">
      <div class="card bg-body border shadow-sm rounded-4 text-body h-100 card-hover-effect">
        <div class="card-body p-3.5 d-flex flex-column justify-content-between">
          <div class="text-body-secondary font-xs fw-bold text-uppercase tracking-wider mb-2">Wave Money</div>
          <div class="fs-5 fw-black font-monospace tracking-tight text-primary-emphasis text-nowrap">
            {{ (totalPaymentNameGroupWaveMon || 0) | number }} <span
              class="font-xs fw-normal text-body-secondary">MMK</span>
          </div>
        </div>
      </div>
    </div>
    }

    <!-- Tier 2 Channel Metrics: KBZPay Wallet Dispersals -->
    @if (bolWKBZ) {
    <div class="col-12 col-sm-6 col-md-4 col-xl">
      <div class="card bg-body border shadow-sm rounded-4 text-body h-100 card-hover-effect">
        <div class="card-body p-3.5 d-flex flex-column justify-content-between">
          <div class="text-body-secondary font-xs fw-bold text-uppercase tracking-wider mb-2">KBZPay</div>
          <div class="fs-5 fw-black font-monospace tracking-tight text-primary-emphasis text-nowrap">
            {{ (totalPaymentNameGroupKBZPay || 0) | number }} <span
              class="font-xs fw-normal text-body-secondary">MMK</span>
          </div>
        </div>
      </div>
    </div>
    }

    <!-- Tier 2 Channel Metrics: AYA Pay Wallet Dispersals -->
    @if (bolWKBZ) {
    <div class="col-12 col-sm-6 col-md-4 col-xl">
      <div class="card bg-body border shadow-sm rounded-4 text-body h-100 card-hover-effect">
        <div class="card-body p-3.5 d-flex flex-column justify-content-between">
          <div class="text-body-secondary font-xs fw-bold text-uppercase tracking-wider mb-2">AYA Pay</div>
          <div class="fs-5 fw-black font-monospace tracking-tight text-primary-emphasis text-nowrap">
            {{ (totalPaymentNameGroupAYA || 0) | number }} <span
              class="font-xs fw-normal text-body-secondary">MMK</span>
          </div>
        </div>
      </div>
    </div>
    }

    <!-- Tier 2 Channel Metrics: Phone Bill Airtime Topups -->
    @if (bolPBTU) {
    <div class="col-12 col-sm-6 col-md-4 col-xl">
      <div class="card bg-body border shadow-sm rounded-4 text-body h-100 card-hover-effect">
        <div class="card-body p-3.5 d-flex flex-column justify-content-between">
          <div class="text-body-secondary font-xs fw-bold text-uppercase tracking-wider mb-2">PhoneBill Topup</div>
          <div class="fs-5 fw-black font-monospace tracking-tight text-primary-emphasis text-nowrap">
            {{ (totalPaymentNameGroupPBTU || 0) | number }} <span
              class="font-xs fw-normal text-body-secondary">MMK</span>
          </div>
        </div>
      </div>
    </div>
    }

  </div>
  }

  <!-- Premium Redemption Ledger Workspace Table Card Wrapper -->
  <div class="card border shadow-sm overflow-hidden bg-body w-100 mb-4 animate-fade">
    <!-- Wrapper controls the horizontal scroll trigger point safely on narrow viewports -->
    <div class="table-responsive-container m-0">
      <table class="table table-hover align-middle mb-0 table-dense text-nowrap">

        <!-- High-Density Dynamic Head Structure Matrix Mapping -->
        <thead
          class="table-light text-body-secondary border-bottom font-monospace small text-uppercase tracking-wider no-copy-elements">
          <tr class="table-light font-monospace small text-uppercase tracking-wider text-body-secondary border-bottom">
            <th scope="col" class="ps-4">No</th>
            <th scope="col" title="Redeem ID">R-ID</th>
            @if (bolPBTU) {
            <th scope="col" title="Transaction ID">T-ID</th>
            }
            <th scope="col" title="Customer Phone">C-Phone</th>
            <th scope="col" title="Payment Name">P-Name</th>
            <th scope="col" title="Payment Phone">P-Phone</th>
            <th scope="col" title="Redeem Item Name">R-Item-Name</th>
            <th scope="col" title="Redeem Item Type">R-Item-Type</th>
            <th scope="col" title="Redeemed TS">R-TS</th>
            <th scope="col" class="text-center" title="Redeem Status">R-Status</th>
            <th scope="col" title="Processed By">P-By</th>
            <th scope="col" title="Processed TS">P-TS</th>
            <th scope="col" class="text-end">Sign By</th>
          </tr>
        </thead>

        <!-- Table Body Row Interpolations Logic Items Loops -->
        <tbody class="small text-body">
          @if (results()) {
          @for (data of results() | paginate : { itemsPerPage: pageSize(), currentPage: page() + 1, totalItems:
          allTotal()
          }; track data.id || $index; let i = $index) {
          <tr class="transition-base">

            <td class="ps-4 font-monospace fw-semibold text-body-secondary">{{ data.srNo }}</td>
            <td>
              <a class="fw-bold" (click)="goToTransactionList(data)" style="cursor: pointer">
                {{ data.id }}
              </a>
            </td>

            @if (bolPBTU) {
            <td class="font-monospace text-body-secondary">{{ data.transactionId || '-' }}</td>
            }

            <td class="font-monospace fw-semibold">{{ data.customerLoginPhone }}</td>
            <td>
              <span class="badge bg-body-secondary text-body border px-2.5 py-1 font-monospace shadow-sm fw-bold">
                {{ data.paymentName }}
              </span>
            </td>
            <td class="font-monospace text-body-secondary">{{ data.paymentPhone }}</td>
            <td class="font-xs">
              <!-- Row Layer 1: Core Provider Name Identifier Block -->
              <div class="d-block text-body fw-bold tracking-wide">
                @if (data.redeemableItemName?.includes('Wave Money')) {
                <span>Wave Money</span>
                } @else if (data.redeemableItemName?.includes('KBZPay')) {
                <span>KBZPay</span>
                } @else if (data.redeemableItemName?.includes('AYA Pay')) {
                <span>AYA Pay</span>
                } @else {
                <!-- Fallback safely handles custom product lines automatically -->
                <span class="text-truncate d-inline-block max-w-120" [title]="data.redeemableItemName">
                  {{ data.redeemableItemName?.split('-')[0]?.trim() }}
                </span>
                }
              </div>

              <!-- Row Layer 2: Explicit Dispersal Cash Metric Annotation Value -->
              <div class="d-block font-monospace text-success-emphasis fw-semibold font-xs mt-0.5">
                @if (data.redeemableItemName?.includes('-')) {
                <!-- Extracts everything following the separator dash lines cleanly -->
                <span>{{ data.redeemableItemName?.split('-')[1]?.trim() }}</span>
                } @else {
                <span class="text-body-secondary opacity-50 fst-italic">—</span>
                }
              </div>
            </td>

            <td class="text-uppercase font-monospace text-body-secondary font-xxs">{{ data.redeemableItemType }}</td>

            <td class="text-body-secondary font-monospace font-xxs">
              <div class="d-block text-body fw-medium">
                {{ data.redeemedTS | date: 'dd-MM-yyyy' }}
              </div>
              <div class="d-block opacity-75 font-xxs">
                {{ data.redeemedTS | date: 'HH:mm:ss' }}
              </div>
            </td>

            <!-- Contextual Status Badges & Secondary Operational Action Inline Row Controls -->
            <td class="text-center">
              <div class="d-flex flex-column align-items-center gap-1.5">

                <span
                  class="badge rounded-pill px-2.5 py-1 text-uppercase font-monospace text-body-secondary tracking-wide bg-opacity-25"
                  [class.bg-success-subtle]="data.redeemableStatus?.toLowerCase() === 'success' || data.redeemableStatus?.toLowerCase() === 'completed'"
                  [class.text-success]="data.redeemableStatus?.toLowerCase() === 'success' || data.redeemableStatus?.toLowerCase() === 'completed'"
                  [class.bg-warning-subtle]="data.redeemableStatus?.toLowerCase()?.includes('customer_redeem') || data.redeemableStatus?.toLowerCase() === 'pending'"
                  [class.text-warning]="data.redeemableStatus?.toLowerCase()?.includes('customer_redeem') || data.redeemableStatus?.toLowerCase() === 'pending'"
                  [class.bg-danger-subtle]="data.redeemableStatus?.toLowerCase() === 'failed' || data.redeemableStatus?.toLowerCase() === 'error' || data.redeemableStatus?.toLowerCase() === 'blocked'"
                  [class.text-danger]="data.redeemableStatus?.toLowerCase() === 'failed' || data.redeemableStatus?.toLowerCase() === 'error' || data.redeemableStatus?.toLowerCase() === 'blocked'">
                  {{ data.redeemableStatus || 'UNKNOWN' }}
                </span>

                <!-- Multi-Operational Inline Execution Micro Keys Grid -->
                <div class="d-inline-flex align-items-center justify-content-center gap-1">

                  @if (showRetryButton && (shouldRenderRetryButton(data) || shouldRenderAdminRetryButton(data))) {
                  <button type="button"
                    class="btn btn-sm btn-icon btn-outline-info rounded-circle shadow-sm transition-base"
                    title="Retry Transaction" [disabled]="isRetryBtnLoading()[i]" (click)="retryRedeem(data, i)">
                    @if (isRetryBtnLoading()[i]) {
                    <span class="spinner-border spinner-border-sm m-0" role="status"></span>
                    } @else {
                    <i class="fa-solid fa-rotate-right font-xs text-info"></i>
                    }
                  </button>
                  }

                  @if (showBlockButton && shouldRenderAdminBlockButton(data)) {
                  <button type="button"
                    class="btn btn-sm btn-icon btn-outline-danger rounded-circle shadow-sm transition-base"
                    title="Block Phone" [disabled]="isBlockBtnLoading()[i]" (click)="blockRedeem(data, i)">
                    @if (isBlockBtnLoading()[i]) {
                    <span class="spinner-border spinner-border-sm m-0" role="status"></span>
                    } @else {
                    <i class="fa-solid fa-ban font-xs text-danger"></i>
                    }
                  </button>
                  }

                  @if (shouldRenderQueryButton(data)) {
                  <button type="button"
                    class="btn btn-sm btn-icon btn-outline-primary rounded-circle shadow-sm transition-base"
                    title="Check Logs" [disabled]="isQueryBtnLoading()[i]"
                    (click)="queryBORedeem(data.id, i)">
                    @if (isQueryBtnLoading()[i]) {
                    <span class="spinner-border spinner-border-sm m-0" role="status"></span>
                    } @else {
                    <i class="fa-solid fa-magnifying-glass font-xs text-primary"></i>
                    }
                  </button>
                  }

                </div>
              </div>
            </td>

            <td class="text-body-secondary" [class.fst-italic]="!data.processedBy"
              [class.opacity-50]="!data.processedBy">
              {{ data.processedBy || 'system' }}
            </td>

            <td class="text-body-secondary font-monospace font-xxs">
              @if (data.processedTS) {
              <!-- Row Layer 1: Calendar Date digits -->
              <div class="d-block text-body fw-medium mb-0.5">
                {{ data.processedTS | date: 'dd-MM-yyyy' }}
              </div>
              <!-- Row Layer 2: Clock Hours notation -->
              <div class="d-block opacity-75 font-xxs text-body-secondary">
                {{ data.processedTS | date: 'HH:mm:ss' }}
              </div>
              } @else {
              <span class="text-body-secondary opacity-50 fst-italic">—</span>
              }
            </td>

            <!-- Primary Security Compliance Sign Off Commands Groups -->
            <td class="text-end font-xs">
              <div class="d-inline-flex align-items-center justify-content-end gap-1.5">
                @if (data.signedBy) {
                <span
                  class="text-nowrap badge bg-secondary text-white font-monospace border px-2 py-1 shadow-sm small fw-semibold">
                  {{ data.signedBy }}
                </span>
                }

                @if (data.redeemableItemType === 'WALLET_CASH_TRANSFER' && data.redeemableStatus === 'CUSTOMER_REDEEM'
                && isSignItemAccess) {
                <!-- Approve Authorization Seal -->
                <button type="button" class="btn btn-sm btn-icon btn-success rounded-circle shadow-sm transition-base"
                  title="Sign & Approve Transaction" [disabled]="isSignBtnLoading()[i]" (click)="signItem(data.id, i)">
                  @if (isSignBtnLoading()[i]) {
                  <span class="spinner-border spinner-border-sm m-0" role="status"></span>
                  } @else {
                  <i class="fa-solid fa-check font-xs text-white"></i>
                  }
                </button>

                <!-- Reject Authorization Seal -->
                <button type="button" class="btn btn-sm btn-icon btn-danger rounded-circle shadow-sm transition-base"
                  title="Fail & Terminate Transaction" [disabled]="isSignBtnLoading()[i]"
                  (click)="prepareFail(data.id, i)" data-bs-toggle="modal" data-bs-target="#showInfoFailedDialog">
                  @if (isSignBtnLoading()[i]) {
                  <span class="spinner-border spinner-border-sm m-0" role="status"></span>
                  } @else {
                  <i class="fa-solid fa-xmark font-xs text-white"></i>
                  }
                </button>
                }
              </div>
            </td>
          </tr>
          }

          }
        </tbody>
      </table>
    </div>
  </div>


  <!-- Custom styled Pagination Layout Element -->
  <div class="d-flex justify-content-center mt-3">
    <pagination-controls [maxSize]="10" previousLabel="&laquo;" nextLabel="&raquo;" [responsive]="true"
      class="dashboard-pagination" (pageChange)="handlePageChange($event)">
    </pagination-controls>
  </div>

</div>

<!-- Floating Mini Card Indicator -->
@if (loading()) {
<div
  class="position-fixed bottom-0 end-0 m-2 z-3 p-3 bg-body card border-info border-opacity-25 shadow-sm d-flex flex-row align-items-center gap-2"
  style="backdrop-filter: blur(4px);">
  <!-- Mini Spinner -->
  <div class="spinner-border text-info" style="width: 1rem; height: 1rem; border-width: 2px;" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>

  <!-- Text Badge Layout (Uses your global micro utilities) -->
  <div class="font-monospace text-info fw-bold tracking-widest text-uppercase pe-1 font-xs">
    Loading...
  </div>
</div>
}

<!-- ========================================== -->
<!-- BULK RECONCILIATION EXPORT REQUEST MODAL   -->
<!-- ========================================== -->
<div class="modal fade" id="downloadCSVModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content shadow-lg border-0 transition-base">

      <!-- Modal Header Banner Frame -->
      <div class="modal-header border-bottom px-4 py-3">
        <h5 class="modal-title fw-bold text-gradient-primary">
          <i class="fa-solid fa-file-csv me-2"></i>Download Request CSV File
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Core Input Fields Frame Body -->
      <div class="modal-body px-4 py-4">
        <div class="mb-0">
          <label class="form-label small fw-bold text-body-secondary mb-2">
            Export Target Document Filename Configuration
          </label>

          <div class="input-group shadow-sm rounded">
            <span class="input-group-text border bg-light text-body-secondary">
              <i class="fa-solid fa-file-signature text-muted font-xs"></i>
            </span>
            <input type="text" class="form-control font-monospace" placeholder="Enter custom export file name..."
              [(ngModel)]="downloadFileName" />
            <span class="input-group-text border font-monospace small bg-light text-body-secondary">
              .csv
            </span>
          </div>

          <div class="form-text font-monospace font-xs mt-2 text-muted">
            * Filename parameter length must contain at least 4 characters to pass system validation.
          </div>
        </div>
      </div>

      <!-- Modal Operational Command Buttons Group Footer -->
      <div class="modal-footer border-top px-4 py-2.5">
        <button type="button" class="btn btn-sm btn-secondary opacity-75 shadow-sm px-3 py-1.5 fw-medium"
          data-bs-dismiss="modal">Close</button>
        <button type="button"
          class="btn btn-sm btn-primary px-4 py-1.5 shadow-sm fw-bold d-inline-flex align-items-center gap-2"
          [disabled]="!downloadFileName || downloadFileName.length <= 3 || apiDownloadLoading()"
          (click)="downloadRequestFile()">
          @if (apiDownloadLoading()) {
          <span class="spinner-border spinner-border-sm" role="status"></span>
          <span>Generating Template...</span>
          } @else {
          <span>Submit Request <i class="fa-solid fa-cloud-arrow-up font-xs"></i></span>
          }
        </button>
      </div>

    </div>
  </div>
</div>

<!-- ========================================== -->
<!-- COMPLIANCE EXCEPTION PROTOCOL REJECTION MODAL -->
<!-- ========================================== -->
<div class="modal fade" id="showInfoFailedDialog" tabindex="-1" role="dialog" aria-hidden="true" cdkDrag>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content shadow-lg border-0 transition-base">

      <!-- Draggable Handle Grab Bar Indicator Block -->
      <div class="cdk-drag-handle-bar bg-light border-bottom text-center text-muted font-xxs py-1 cursor-grab"
        title="Drag to re-position modal screen layout">
        <i class="fa-solid fa-grip-lines opacity-50"></i>
      </div>

      <!-- Modal Header Banner Frame -->
      <div class="modal-header px-4 py-3">
        <h5 class="modal-title fw-bold text-danger d-inline-flex align-items-center gap-2">
          <i class="fa-solid fa-circle-exclamation fs-5"></i>Flag Redeem Item As Failed
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Core Input Fields Frame Body -->
      <div class="modal-body px-4 py-3 d-flex flex-column gap-3">

        <!-- Target Financial Channel Selector Field Dropdown -->
        <div class="filter-input-field w-100">
          <label for="customer_type" class="form-label small fw-bold text-body-secondary mb-1.5">
            Redeemable Provider Channel Gateway
          </label>
          <select class="form-select shadow-sm font-monospace small" id="customer_type" name="customer_type"
            [(ngModel)]="redeemableProvider">
            <option value="WAVEPAY">WAVEPAY (Wave Money)</option>
            <option value="AYAPAY">AYAPAY (AYA Bank)</option>
          </select>
        </div>

        <!-- Compliance Audit Annotation Note Field Textarea -->
        <div class="filter-input-field w-100">
          <label class="form-label small fw-bold text-body-secondary mb-1.5">
            Audit Exception Info Remark Note
          </label>
          <textarea class="form-control shadow-sm font-monospace small" rows="3"
            placeholder="Provide concise structural rationale explaining payment denial or transactional exception details here..."
            [(ngModel)]="infoRemark" maxlength="128"></textarea>
          <div class="d-flex justify-content-end text-muted font-xxs mt-1">
            <span>{{ infoRemark.length || 0 }} / 128 characters max</span>
          </div>
        </div>

      </div>

      <!-- Modal Operational Command Buttons Group Footer -->
      <div class="modal-footer border-top px-4 py-2.5 justify-content-between">
        <button type="button" class="btn btn-sm btn-outline-danger px-3 py-1.5 shadow-sm fw-semibold"
          data-bs-dismiss="modal">Close Window</button>
        <button type="button"
          class="btn btn-sm btn-primary px-4 py-1.5 shadow-sm fw-bold d-inline-flex align-items-center gap-2"
          [disabled]="!infoRemark" (click)="confirmFail()">
          <span>Terminate Settlement <i class="fa-solid fa-circle-right font-xs"></i></span>
        </button>
      </div>

    </div>
  </div>
</div>